module.exports = __webpack_public_path__ + "media/images/logo-black-38765d473e520ac0874c12e609ae38c2.svg";